import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDegustationLeadForm } from '../../api/fetch-degustation-lead-form';

export const fetchDegustationLeadFormThunk = createAsyncThunk(
    'fetchDegustationLeadForm',
    async () => fetchDegustationLeadForm(),
);
